import React, { memo, useCallback, useState } from 'react'
import { Typography } from '@mui/material'
import { translate } from '../i18n'
import { unblockUser, unblockTenantUser } from '../api'
import { DialogPopup } from '../components'
import { UserUnblockPopupProps } from './UserUnblockPopup.types'

function UserUnblockPopup({
    user,
    tenantId,
    onCancelled,
    onCompleted,
    onError,
}: UserUnblockPopupProps) {
    const [submitting, setSubmitting] = useState<boolean>(false)

    const unblockPromise = useCallback((): Promise<void> => {
        if (tenantId) {
            return unblockTenantUser(tenantId, user.id)
        }
        return unblockUser(user.id)
    }, [tenantId, user])

    const onConfirm = useCallback(() => {
        setSubmitting(true)
        unblockPromise()
            .then(() => {
                setSubmitting(false)
                onCompleted()
            })
            .catch((error) => {
                setSubmitting(false)
                onError(error.message)
            })
    }, [unblockPromise, onCompleted, onError])

    return (
        <DialogPopup
            open
            variant="primary"
            title={translate('users.unblock.title') as string}
            disableEscapeKeyDown={submitting}
            disableBackdropClick={submitting}
            disable={submitting}
            closeText={translate('buttons.cancel') as string}
            onClose={onCancelled}
            button={{
                text: translate('buttons.unblock'),
                onClick: onConfirm,
                disabled: submitting,
            }}
        >
            <Typography variant="body2">
                {translate('users.unblock.description', {
                    first_name: user.first_name,
                })}
            </Typography>
        </DialogPopup>
    )
}

export default memo(UserUnblockPopup)
